import { Button } from 'common-components'
import styled, { css } from 'styled-components'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'

interface IProps {
  $isDisabled: boolean
  $isTtsGenerationLoading: boolean
  $isPremium: boolean
}

export const GenerateButtonContainer = styled(Button)<IProps>`
  padding: 10px 23px;
  width: 100%;

  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  transition:
    opacity 0.3s,
    background-color 0.3s;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
      cursor: default;
    `}

  .loading-spinner {
    width: unset;
    height: unset;
  }

  ${premiumButtonStyles};
`
